import wearables from '../../../../shared/images/ss-hub/Wearables_gray.png';
import loadMonitoring from '../../../../shared/images/ss-hub/Load-monitoring_gray.png';
import sportCoach from '../../../../shared/images/ss-hub/Sports-coach_gray.png';
import recoveryRadar from '../../../../shared/images/ss-hub/Radar_gray.png';
import habitTrack from '../../../../shared/images/ss-hub/Consistency_gray.png';
import forcePlate from '../../../../shared/images/ss-hub/Force-plate_gray.png';
import volumeTracker from '../../../../shared/images/ss-hub/Volume-tracker_gray.png';
import bhmOnboardingImageOne from '../../../../shared/images/rr-onboarding-one.png';
import bhmOnboardingImageTwo from '../../../../shared/images/rr-onboarding-two.png';
import bhmOnboardingImageThree from '../../../../shared/images/rr-onboarding-three.png';
import bhmOnboardingImageFour from '../../../../shared/images/rr-onboarding-four.png';
import bhmOnboardingImageFive from '../../../../shared/images/rr-onboarding-five.png';
import htOnboardingImageOne from '../../../../shared/images/ht-onboarding-one.png';
import htOnboardingImageTwo from '../../../../shared/images/ht-onboarding-two.png';
import htOnboardingImageThree from '../../../../shared/images/ht-onboarding-three.png';
import htOnboardingImageFour from '../../../../shared/images/ht-onboarding-four.png';
import vtOnboardingImageOne from '../../../../shared/images/vt-onboarding-one.png';
import vtOnboardingImageTwo from '../../../../shared/images/vt-onboarding-two.png';
import vtOnboardingImageThree from '../../../../shared/images/vt-onboarding-three.png';
import vtOnboardingImageFour from '../../../../shared/images/vt-onboarding-four.png';
import vbtOnboardingImageOne from '../../../../shared/images/vbtOnboarding1.png';
import vbtOnboardingImageThree from '../../../../shared/images/vbtOnboarding3.png';

const gradients = {
  included: null,
  core: 'linear-gradient(270deg, #fc4a1a 0%, #f7b733 100%)',
  addOn: 'linear-gradient(270deg, #6A82FB 0%, #FC5C7D 100%)',
};

// Moving forward packages won't have 'sections' (July '25)
// 'content' will be used for both upgrade and onboarding modals
const corePackage = {
  title: 'Core Subscription',
  core: true,
  unlocked: false,
  description: 'See the bigger picture and get more from your TeamBuildr data',
  sections: [
    {
      name: 'Monitoring',
      description:
        'Generate insights based on athlete workload and self-reported questionnaire data.',
      icon: 'clipboard',
    },
    {
      name: 'Readiness',
      description:
        'Evaluate readiness by viewing health metrics from wearable devices like HRV, heart rate, and more.',
      icon: 'heart-rate',
    },
    {
      name: 'Recovery',
      description:
        'Understand individualized responses to training and competition through customizable questionnaires.',
      icon: 'circuit',
    },
  ],
  icon: 'chart-line',
  videoUrl: 'https://www.youtube.com/watch?v=_QV5pVHHIEs',
};

export const includedModules = [
  {
    id: 1,
    title: 'Wearables Dashboard',
    legacyTitle: '',
    addOnId: null,
    core: false,
    unlocked: true,
    description: 'Quickly review biometric data collected by wearable devices',
    sections: [
      {
        name: 'Track Beyond PRs and Maxes',
        description:
          'Track athletes\' progress with real-time insights into calories burned, average heart rate, steps taken, heart rate variability (HRV), and sleep hours.',
        icon: 'watch-sync',
      },
      {
        name: 'Understand Training Fatigue',
        description:
          'Monitor exertion and recovery levels, categorizing fatigue as Heavy, Slight, Moderate, or Well Rested.',
        icon: 'sleep-moon',
      },
      {
        name: 'Make Sense of the Data',
        description:
          'Dive deeper with Exertion Scores for individuals, teams, or groups, and analyze trends over days, weeks, or months.',
        icon: 'target',
      },
    ],
    icon: 'watch-heart-rate',
    activeTab: '/ams/wearables-dashboard',
    backgroundImage: wearables,
    gradient: gradients.included,
    subscriptionName: 'Included in your plan',
    videoUrl: 'https://www.youtube.com/watch?v=AtnUuF2A-Bk&t=1s',
  },
];

export const coreModules = [
  {
    id: 2,
    title: 'Load Monitoring Dashboard',
    legacyTitle: '',
    addOnId: null,
    core: true,
    unlocked: false,
    description: 'Compare athlete weight room load to questionnaire responses',
    sections: [
      {
        name: 'Monitoring',
        description:
          'Generate insights based on athlete workload and self-reported questionnaire data.',
        icon: 'chart-line',
      },
      {
        name: 'Readiness',
        description:
          'Determine athlete readiness by viewing data regarding sleep, fatigue, motivation, stress levels, and more.',
        icon: 'heart-rate',
      },
      {
        name: 'Recovery',
        description:
          'See how your athletes are recovering from competition and training sessions.',
        icon: 'circuit',
      },
    ],
    videoUrl: 'https://www.youtube.com/watch?v=soAvDS3obS0',
    icon: 'chart-line',
    activeTab: '/ams/load-monitoring-dashboard',
    backgroundImage: loadMonitoring,
    gradient: gradients.core,
    subscriptionName: 'Core Subscription',
  },
  {
    id: 3,
    title: 'KPI Tracker',
    legacyTitle: 'Sport Coach Dashboard',
    addOnId: null,
    core: true,
    unlocked: false,
    description: 'Share athlete workout data with athlete stakeholders',
    sections: [
      {
        name: 'Collaborate',
        description:
          'Share workout data with athlete stakeholders so they can see how their athletes are progressing.',
        icon: 'fist-bump-full-together',
      },
      {
        name: 'Monitor Progress',
        description:
          'All stakeholders can easily see when athletes hit a new max or personal best.',
        icon: 'clipboard',
      },
      {
        name: 'Identify Trends',
        description:
          'See how each athlete is developing compared to the rest of the team.',
        icon: 'group',
      },
    ],
    videoUrl: 'https://www.youtube.com/watch?v=ZRtmL63e62c',
    icon: 'clipboard',
    activeTab: '/ams/kpi-tracker',
    backgroundImage: sportCoach,
    gradient: gradients.core,
    subscriptionName: 'Core Subscription',
  },
  {
    id: 4,
    title: 'Body Heatmap',
    legacyTitle: 'Recovery Radar',
    addOnId: null,
    core: true,
    unlocked: false,
    description: 'Monitor athletes experiencing any pain or soreness',
    // UPDATE STILL NEEDED FOR SECTIONS
    sections: [
      {
        name: 'Collaborate',
        description:
          'Share individual athlete workout data with Sport Coaches so they can see how their athletes are progressing.',
        icon: 'fist-bump-full-together',
      },
      {
        name: 'Monitor Progress',
        description:
          'Sport & Performance coaches can easily see when athletes hit a new max or personal best.',
        icon: 'clipboard',
      },
      {
        name: 'Team Trends',
        description:
          'See how each athlete is developing compared to the rest of the team.',
        icon: 'group',
      },
    ],
    content: [
      {
        videoUrl: 'https://www.youtube.com/watch?v=iJbmYLH90PE&t=161s',
        image: bhmOnboardingImageOne,
        title: 'Accessing Body Heatmap',
        description:
          'Welcome to Body Heatmap, where athletes can log any pain or soreness they experience, enabling coaches to monitor needed adjustments. To get started, athletes log data on the TeamBuildr mobile app by navigating to Body Heatmap in the navigation drawer or by selecting "More" in the Workout Entry screen.',
        gradientType: 'primary',
      },
      {
        image: bhmOnboardingImageTwo,
        title: 'Reporting and Tracking Pain and Soreness',
        description:
          'To log pain or soreness, athletes open Body Heatmap on the mobile app. On the body heatmap, athletes tap a specific area to report, selecting either Pain or Soreness and choosing a severity level (1 to 7). Optional fields like Region and Status allow athletes to add context for coaches. Each entry saves automatically in the Areas Selected section, building a structured record that coaches can view and analyze.',
        gradientType: 'primary',
      },
      {
        image: bhmOnboardingImageThree,
        title: 'Overview of Recovery Data',
        description:
          'In the Overview tab, coaches can view a high-level summary of pain and soreness data at a group and individual level. To begin, select a group from the dropdown menu in the top left corner. Use the date selector in the top right to choose a 7-day or 28-day range, showing trends for each body part. A line graph tracks changes over time, while a body map highlights frequently reported areas. Below, quick stat cards display Total Reported Items, Average Severity, and the number of Athletes to Review.',
        gradientType: 'primary',
      },
      {
        image: bhmOnboardingImageFour,
        title: 'Analyzing Athlete Recovery',
        description:
          'To review individual reports, open the Group Analysis tab and select a group from the dropdown menu. The table shows each athlete’s reported body part, severity, 28-day average, and any notes. For a detailed view, click on an athlete’s name to open the Athlete History tab, which displays their body heatmap and a list of reported issues over time.',
        gradientType: 'primary',
      },
      {
        image: bhmOnboardingImageFive,
        title: 'Athlete Alerts',
        description:
          'Athlete Alerts help coaches quickly identify athletes with significant increases in average severity, allowing them to prioritize athletes needing immediate attention. Click "Review" in the red alert banner to filter these athletes into the Group Analysis table for closer monitoring.',
        gradientType: 'primary',
      },
    ],
    // UPDATE STILL NEEDED FOR VIDEOURL
    videoUrl: 'https://www.youtube.com/watch?v=iJbmYLH90PE&t=161s',
    icon: 'body-dots',
    activeTab: '/ams/body-heatmap',
    backgroundImage: recoveryRadar,
    gradient: gradients.core,
    subscriptionName: 'Core Subscription',
  },
  {
    id: 5,
    title: 'Habit Tracker',
    legacyTitle: 'Consistency Coach',
    addOnId: null,
    core: true,
    unlocked: false,
    description: 'Create, assign, and monitor habits for users',
    sections: [
      {
        name: 'Create Consistency',
        description:
          'Create, manage, and assign custom habits for athletes to complete throughout the day or week.',
        icon: 'checkmark',
      },
      {
        name: 'Habit Monitoring',
        description:
          'Keep an eye on daily and weekly progress as athletes check off habits and log data into their app.',
        icon: 'chart',
      },
      {
        name: 'Stakeholder Collaboration',
        description:
          'Allow habits to be viewed by Sport Coaches, Athletic Trainers, Wellness Professionals, and other stakeholders.',
        icon: 'group',
      },
    ],
    content: [
      {
        videoUrl: 'https://www.youtube.com/watch?v=rTr7DW2eNSI',
        image: htOnboardingImageOne,
        title: 'Create & Categorize Habits',
        description:
          'To begin habit tracking inside TeamBuildr, start out by creating habits inside the web app so they appear for your athletes. Habits need a category assigned in order to view the collected data in Group & Individual Analysis.',
        gradientType: 'primary',
      },
      {
        image: htOnboardingImageTwo,
        title: 'Completion Overview',
        description:
          'In the Completion Overview tab, select a group from the dropdown menu in the top left corner to view the collected data, and choose a week range in the top right. It is possible to go back at a max of 12 weeks from a selected day. The date selector will automatically detect the week range you select. Collected data starts on Monday and ends on Sunday.',
        gradientType: 'primary',
      },
      {
        image: htOnboardingImageThree,
        title: 'Group Analysis',
        description:
          'The Group Analysis tab allows you to view a table of athletes and their assigned habit data, either individually or as a full group. You can select up to 10 habits in this view by filtering them, the filter can be found to the right of the selected group or athlete. In this view, you are also able to dynamically set thresholds for each habit. Thresholds will be removed if the browser is closed or you move out of habit tracking inside the same browser window.',
        gradientType: 'primary',
      },
      {
        image: htOnboardingImageFour,
        title: 'Data Visibility',
        description:
          'Data will not appear for habits that do not have a category assigned to it. If you delete a category, all associated habits will still be there, but they will need to be assigned a new category in order to view it in the Group and Individual analysis tabs.',
        gradientType: 'primary',
      },
    ],
    videoUrl: 'https://www.youtube.com/watch?v=rTr7DW2eNSI',
    icon: 'checkmark',
    activeTab: '/ams/habit-tracker',
    backgroundImage: habitTrack,
    gradient: gradients.core,
    subscriptionName: 'Core Subscription',
  },
  {
    id: 7,
    title: 'Volume Tracker',
    legacyTitle: '',
    addOnId: null,
    core: true,
    unlocked: false,
    sections: [
      {
        name: 'Integrated',
        description:
          'Using imported data from our 2 partners - Hawkin Dynamic and VALD - our Force Plate Module rethinks how to display external data.',
        icon: 'force-plate',
      },
      {
        name: 'Summarize',
        description:
          'This module takes the simple approach to viewing Force Plate data by reading fewer metrics and highlighting unique values and trends.',
        icon: 'file',
      },
      {
        name: 'Groups vs. Individual',
        description:
          'Visualize force-velocity trends and profiles for an individual or a team, or position group - with trend analysis.',
        icon: 'conversation-group',
      },
    ],
    content: [
      {
        videoUrl: 'https://www.youtube.com/watch?v=aGjTAntIe70',
        image: vtOnboardingImageOne,
        title: 'Monitor Program Adherence & Progression',
        description:
          'The Volume Tracker makes keeping tabs on group wide workout progression quick and easy. Alternate between views to make informed decisions on any changes that may be necessary, to ensure consistent progression towards athlete goals and program outcomes.',
        gradientType: 'primary',
      },
      {
        image: vtOnboardingImageTwo,
        title: 'Overview',
        description:
          'Toggle between group averages and individual completion results. View total rep count within customizable Percentage Intensity Buckets. All reps completed by a group or individual will populate per percentage intensity bucket they completed when compared to their assigned max. View the total tonnage progression by hovering over a bar.',
        gradientType: 'primary',
      },
      {
        image: vtOnboardingImageThree,
        title: 'Assigned vs Completed',
        description:
          'Quickly view what you assigned per Percentage Intensity Bucket compared to what the group actually completed. Identify if the group or individual is going too heavy or too light, compared to what you intended them to do. Gain actionable information to keep athletes on track to their goals!',
        gradientType: 'primary',
      },
      {
        image: vtOnboardingImageFour,
        title: 'Calculations',
        description:
          `Coach will prescribe an exercise, a rep and set scheme, and a percentage intensity or weight. This will be considered in the "Assigned Tonnage" calculation. An athlete will perform the prescribed sets and reps at a specific weight. This will be the Completed Tonnage.
          Example: Back Squat
          Assigned: 2 Sets, 5 Reps at 80lbs (80% of 100lbs max) = 800lbs total tonnage
          Completed: 2 Sets, 5 Reps at 70lbs (70% of 100lbs max) = 700lbs total tonnage
          In this example you can see where the athlete deviated from the assigned and how far off they were from the intended goal.`,
        gradientType: 'primary',
      },
    ],
    videoUrl: 'https://www.youtube.com/watch?v=aGjTAntIe70',
    description: 'View detailed exercise volume data for groups and individuals',
    icon: 'chart-line-bars',
    gradient: gradients.core,
    activeTab: '/ams/volume-tracker',
    backgroundImage: volumeTracker,
  },
];

export const getFilteredCoreModules = (featureFlags) => coreModules.filter((module) => {
  const moduleFlags = {
    4: featureFlags.bodyHeatMaps,
    5: featureFlags.habitTracking,
    7: featureFlags.volumeTracker,
  };
  return moduleFlags[module.id] ?? true;
});

export const addOns = [
  {
    id: 6,
    title: 'Force Plate Dashboard',
    legacyTitle: '',
    addOnId: 1,
    core: false,
    unlocked: false,
    description: 'Monitor group and athlete data collected with force plates',
    sections: [
      {
        name: 'Integrated',
        description:
          'Using imported data from our 2 partners - Hawkin Dynamic and VALD - our Force Plate Module rethinks how to display external data.',
        icon: 'force-plate',
      },
      {
        name: 'Summarize',
        description:
          'This module takes the simple approach to viewing Force Plate data by reading fewer metrics and highlighting unique values and trends.',
        icon: 'file',
      },
      {
        name: 'Groups vs. Individual',
        description:
          'Visualize force-velocity trends and profiles for an individual or a team, or position group - with trend analysis.',
        icon: 'conversation-group',
      },
    ],
    videoUrl: 'https://www.youtube.com/watch?v=wpzZlqbBeME',
    icon: 'force-plate',
    activeTab: '/ams/force-plate-dashboard',
    backgroundImage: forcePlate,
    gradient: gradients.addOn,
    subscriptionName: 'Add On',
  },
  {
    id: 8,
    title: 'VBT Dashboard',
    legacyTitle: '',
    addOnId: 2,
    core: false,
    unlocked: false,
    description: 'Visualize load relative to velocity from your synced VBT device',
    content: [
      {
        videoUrl: 'https://youtu.be/olU_cfQ4-Os',
        image: vbtOnboardingImageOne,
        title: 'Visualize and Track Data From VBT Devices',
        description:
        'The VBT dashboard brings together data from devices paired with lifts, without the need for manual input, helping you make faster and more informed decisions about your programming and athlete progressions.',
        gradientType: 'primary',
      },
      {
        image: vbtOnboardingImageOne,
        title: 'Sync',
        description:
          'Using imported data from eligible VBT devices, our VBT dashboard allows for custom visualizations of loads relative to velocity by individual and by group.',
        gradientType: 'primary',
      },
      {
        image: vbtOnboardingImageThree,
        title: 'VBT Dashboard',
        description:
          'Visualize load relative to velocity from your synced VBT device.',
        gradientType: 'primary',
      },
    ],
    videoUrl: 'https://youtu.be/olU_cfQ4-Os',
    icon: 'vbt-dash',
    activeTab: '/ams/vbt-dashboard',
    backgroundImage: forcePlate,
    gradient: gradients.addOn,
    subscriptionName: 'Add On',
  },
];

const allModules = [
  ...includedModules,
  ...coreModules,
  ...addOns,
];

// Utility function that gets all information for dashboard by passing in its title as string.
// Used to open informational modal in AMS pages
export const getModuleInfoByTitle = (moduleTitle) => (
  allModules.find((module) => module.title === moduleTitle)
);

// Utility function to update packages based on subscription status
export const updatePackages = (packages, subscriptionStatus, isCorePackageSubscribed) => {
  if (!subscriptionStatus || !subscriptionStatus.packageSubscriptionStatus) {
    return packages;
  }

  return packages.map((packageItem) => {
    let unlocked = false;
    if ((packageItem.core && isCorePackageSubscribed) || packageItem.id === 1) {
      unlocked = true;
    } else if (!packageItem.core) {
      const packageId = packageItem.addOnId;
      // Find the add-on subscription status by addOnId
      const addOnSubscription = subscriptionStatus.addOnsSubscriptionStatus.find(
        (addOn) => addOn.addOnId === packageId,
      );
      const isPackageSubscribed = addOnSubscription?.isSubscribed;
      unlocked = !!isPackageSubscribed;
    }

    return {
      ...packageItem,
      unlocked,
    };
  });
};

// Utility function to compare two arrays of packages
export const arePackagesEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i += 1) {
    if (arr1[i].unlocked !== arr2[i].unlocked) {
      return false;
    }
  }
  return true;
};

export default corePackage;
